import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { roles_roleName, User } from 'src/app/shared/models/interfaces';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NavComponent {
  isMobile: boolean = false;
  isMobileMenuOpen: boolean = false;
  isGroupAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  user: User | null = null;
  constructor(private authService: AuthService) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.authService.getActiveUser().subscribe((user) => {
      this.user = user;
      this.isGroupAdmin = user?.role === roles_roleName.groupAdmin;
      this.isSuperAdmin = user?.role === roles_roleName.superAdmin;
    });
  }

  getDisplayRole(user: User | null | undefined): string {
    switch (user?.role) {
      case roles_roleName.superAdmin:
        return 'Super Admin';
      case roles_roleName.organizationAdmin:
        return 'Organization Admin';
      case roles_roleName.groupAdmin:
        return 'Group Admin';
      case roles_roleName.researcher:
        return 'Researcher';
      case roles_roleName.anonymized:
        return 'Anonymized';
      default:
        return 'Student';
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
    if (!this.isMobile) {
      this.isMobileMenuOpen = false;
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    if (this.isMobile) {
      this.isMobileMenuOpen = false;
    }
  }

  logout() {
    this.authService.onLogoutClick();
  }
}
